import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { path: "/", label: "ホーム" },
  { path: "/services", label: "事業内容" },
  { path: "/safety", label: "安全管理体制" },
  { path: "/about", label: "会社概要" },
  { path: "/careers", label: "採用" },
  { path: "/contact", label: "お問い合わせ" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled || !isHome
          ? "bg-white/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="flex items-center justify-between px-4 md:px-8 lg:px-12 h-16 md:h-20">
        <div />

        <div className="hidden md:flex items-center gap-1 lg:gap-2">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`px-3 lg:px-4 py-2 text-sm font-medium rounded-md transition-all whitespace-nowrap ${
                location.pathname === link.path
                  ? scrolled || !isHome
                    ? "text-ocean-500 bg-ocean-100"
                    : "text-white bg-white/20"
                  : scrolled || !isHome
                    ? "text-ocean-700 hover:text-ocean-500 hover:bg-ocean-50"
                    : "text-white/90 hover:text-white hover:bg-white/15"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
            scrolled || !isHome
              ? "text-ocean-800 hover:bg-ocean-50"
              : "text-white hover:bg-white/15"
          }`}
          aria-label="メニュー"
        >
          <i className={`ri-${mobileOpen ? "close" : "menu"}-line text-xl`} />
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-white/98 backdrop-blur-md border-t border-ocean-100 shadow-lg">
          <div className="px-4 py-3 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block px-4 py-3 text-sm font-medium rounded-lg transition-colors ${
                  location.pathname === link.path
                    ? "text-ocean-500 bg-ocean-50"
                    : "text-ocean-700 hover:text-ocean-500 hover:bg-ocean-50"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}